import { NavItem } from "@closer/ui";
import { useLocation, useNavigate } from "react-router";

import { useAuth } from "../lib/authContext";
import { visibleNavItems } from "../lib/navigation";
import { navIcon } from "./navIcons";

/** Daraltma tercihi tarayıcıda kalıyor — hesap düzeyi tercihler `[066]`'nın konusu. */
const COLLAPSE_STORAGE_KEY = "sidebarCollapsed";

export function readSidebarCollapsed(): boolean {
  return localStorage.getItem(COLLAPSE_STORAGE_KEY) === "1";
}

export function writeSidebarCollapsed(collapsed: boolean): void {
  localStorage.setItem(COLLAPSE_STORAGE_KEY, collapsed ? "1" : "0");
}

export interface SidebarProps {
  collapsed: boolean;
  /**
   * Bir öğe seçildiğinde çağrılır. Mobil drawer bunu kullanarak kapanıyor — kart:
   * *"seçim sonrası gerekli durumda kapanır."* Masaüstünde no-op.
   */
  onNavigate?: () => void;
}

/**
 * Masaüstü sidebar gezinmesi (CLOS-96 `[057]`).
 *
 * ### Görünürlük nereden geliyor
 *
 * `visibleNavItems` üç filtreyi birlikte uyguluyor: sayfası olmayan öğe, tür kapsamı
 * dışındaki öğe ve yetkisi olmayan öğe çizilmiyor. Yetki kümesi `[043]`'ün bağlam
 * ucundan — yani CLOS-84'ün motorundan — geliyor; burada ikinci bir hesap yok.
 *
 * ⚠ Menüyü gizlemek bir GÜVENLİK SINIRI DEĞİL. Gerçek kapı her uçtaki `requirePermission`;
 * kart da bunu şart koşuyor (*"yalnız istemci tarafında menü gizlemeye dayanmaz"*).
 *
 * ### Çalışma alanı değişince menü yenilenir
 *
 * Kendiliğinden: `can` aktif bağlamdan türüyor ve bağlam alan değişiminde yeniden
 * yükleniyor (`[043]`). Ayrı bir tazeleme çağrısı yok — olsaydı ikinci bir gerçek kaynağı
 * doğardı.
 */
export function Sidebar({ collapsed, onNavigate }: SidebarProps) {
  const { activeTenant, can } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const items = visibleNavItems(activeTenant?.type, can);

  return (
    <nav className="flex flex-1 flex-col gap-1 px-3 py-4" aria-label="Ana gezinme">
      {items.map((item) => (
        <NavItem
          key={item.key}
          label={item.label}
          collapsed={collapsed}
          /**
           * Ana Sayfa `/app` ve alt rotalar onun altında doğacak; `startsWith` yerine tam
           * eşleşme kullanılıyor ki ileride `/app/contracts` açıldığında Ana Sayfa da
           * aktif görünmesin.
           */
          active={location.pathname === item.route}
          /**
           * ⚠ İkon DARALTILMIŞ VE GENİŞ durumda AYNI. Eskiden yalnız daraltılmışken bir
           * baş harf çiziliyordu; genişletince öğeler çıplak metne dönüşüyor, daraltınca
           * "S" ile "Ş" gibi baş harfler birbirine karışıyordu. İkon her iki durumda da
           * aynı şeyi gösteriyor, daralma yalnız etiketi kaldırıyor.
           */
          icon={navIcon(item.key)}
          onClick={() => {
            if (item.route) navigate(item.route);
            onNavigate?.();
          }}
        />
      ))}
    </nav>
  );
}
